
riot.tag2('pay-system-params-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{parent.opts.title || \'Новый параметр\'}</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group {has-error: error.code}">\n              <label class="control-label">Код</label>\n              <input class="form-control" name="code" value="{item.code}">\n              <div class="help-block">{error.code}</div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Заголовок</label>\n              <input class="form-control" name="name" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group {has-error: error.value}">\n              <label class="control-label">Значение</label>\n              <textarea class="form-control" name="value" value="{item.value}" type="{type}"></textarea>\n              <div class="help-block">{error.value}</div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.error = false;
    modal.isNew = opts.isNew || false;
    modal.item = opts.item || {};
    modal.mixin('validation');
    modal.mixin('change');

    modal.type = 'text';

    modal.rules = {
        code: 'empty',
        name: 'empty',
        value: 'empty'
    };

    modal.afterChange = function (e) {
        var name = e.target.name;
        delete modal.error[name];
        modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
    };
});
});


// WEBPACK FOOTER //
// ./pages/settings/paysystems/pay-system-params-edit-modal.tag